import { useCallback } from 'react';

function usePasteImage() {
  const handlePaste = useCallback(
    (
      event: React.ClipboardEvent<HTMLDivElement>,
      successCallback: (file: File) => void,
      failCallback?: (error: unknown) => void
    ) => {
      try {
        let file = null;
        const items = event.clipboardData.items;

        if (items && items.length) {
          for (let i = 0; i < items.length; i++) {
            if (items[i].type.includes('image')) {
              file = items[i].getAsFile();
              break;
            }
          }
        }

        if (file) {
          successCallback(file);
        }
      } catch (error) {
        failCallback?.(error);
      }
    },
    []
  );

  return { handlePaste };
}

export default usePasteImage;
